import { default as ToolTipGeneralInfo } from "../../../shared/components/tooltip/tooltip";
import { getAllDataNonTable, postSingleNonTable, getAllData } from "../../../shared/utils/api";

import { Chart as ChartJS } from "chart.js";
import { useState, useEffect, Fragment, useContext, useMemo,  useRef } from "react";
import { Button } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import { AiOutlinePlus } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { BsLockFill, BsFillSendCheckFill, BsFillUnlockFill, BsFillEyeFill } from "react-icons/bs";
import { FaCheck, FaFileDownload, FaSave, FaTimes } from "react-icons/fa";
import { FaFilePdf, FaDownload, } from "react-icons/fa6";

import Wizzard from "../../../shared/components/wizzard/wizzard";

import { useNavigate } from "react-router-dom";

import NormalTableHoc from "./normal-table-hoc";

import "./report-details.scss";
import { GrHistory } from "react-icons/gr";
import { useParams } from "react-router";
import {useHttpNonTable} from "../../../shared/hooks/use-httpNonTable";
import AuthContext from "../../../shared/context/auth-context";

import { IPreparedItem } from "../../../analytics/pages/create-pdf/create-pdf";
import { Preview } from "../../../analytics/pages/create-pdf/preview";
import CustomCheckbox from "../../../shared/components/custom-checkbox/custom-checkbox";
import { ITableRowData, IColumn, IAnyString } from "../../../shared/components/normal-table/normal-table";
import SimpleModal from "../../../shared/components/simple-modal/simple-modal";
import Spinner from "../../../shared/components/spinner/spinner";
import TextInput from "../../../shared/components/text-input/text-input";
import WidgetsLayout, { IConfig, IBlock, IOption, IStep, ISettings, ILayout} from "../../../shared/components/widgets-layout/widgets-layout";
import { roleWrite, roleRead } from "../../../shared/constants/user-roles";
import useHttp from "../../../shared/hooks/use-http";
import { RenderFields } from "../../../shared/utils/render-fields";
import { widgetOptions, reportWidgetSources, modelKeys, sourceDataKeys, crossValidationKeys, widgetType, modelCols, textWidgetOptionsReport } from "../../../shared/utils/static-values";
import { useBack } from "../../../shared/utils/use-back";
import { usePrompt } from "../../../shared/utils/use-prompt";
import { createUUID, convertKeyIntoName } from "../../../shared/utils/utils";
import { rationToPercents2Decimals, filterArrOfObjByString, validateLoadingStatusNew, onlyUnique, defineStep, randomHexColorCode, transformObjectsFracs } from "../../../shared/utils/utils";
import {  populateResultsObj, coreMetrics, IChartResultsCols, metrics6, metrics5, metrics4, subCoreMetrics, productionModalCols, subCoreDetailsMetrics, defaultLayout } from "./report-details-columns";
import { convertModelconfigValueToFrontendValue, convertModelconfigKeyToName, modelConfigKeyMapping } from "./modelconfig-types";
import ChartHoc from "./chart-hoc";

interface ICustomModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  children: React.ReactNode;
  confirmButtonText: string;
  onConfirm: (() => void) | undefined;
}
interface IModalState {
  isOpen: boolean;
  rowId: string | undefined;
  isBack?: boolean | undefined;
}

export interface IParentData {
  parentTabsWidgetData: IBlock[], 
  widgetId: string, 
}

export interface ISelectedRowsData {
  fullData: ITableRowData[],
  idsOnly: string[]
}

export interface IChartDataset {
  label: string,
  data: string[] | number[] | string,
  borderColor: string,
  backgroundColor: string,
  key: string,
  yAxisID?: string
}

export interface IMultyChart {
  datasets: IChartDataset[],
  labels : string[]
}

export interface IBtnOption {
  name: string,
  id : string
}

export interface IExtractedKey {
  resultKeysExtr: string[],
  crossValidationKeysExtr: string[],
  historyKeysExtr: string[],
  modelKeysExtr: string[],
  sourceDataKeysExtr: string[]
}

export interface IData {
  className: string,
  items: IBlock[],
  rowHeight: number,
  cols: number,
}

const ReportDetails = () => {
  const [resultChartData, setResultChartData] = useState<IMultyChart>({labels: [], datasets: []});

  const [extKeys, setExtKeys] = useState<IExtractedKey>({resultKeysExtr:[],crossValidationKeysExtr:[],historyKeysExtr:[],modelKeysExtr:modelCols,sourceDataKeysExtr:[]});

  const [resultDataColsWithLabels, setResultDataColsWithLabels] = useState(undefined);
  const [resultDataColsWithLabelsTransformed, setResultDataColsWithLabelsTransformed] = useState<IBtnOption[] | undefined>(undefined);

  const [historyDataColsWithLabels, setHistoryDataColsWithLabels] = useState(undefined);
  const [historyDataColsWithLabelsTransformed, setHistoryDataColsWithLabelsTransformed] = useState<IBtnOption[] | undefined>(undefined);

  const [resultSelectedUniqueCols, setResultSelectedUniqueCols] = useState<undefined | string[]>(undefined);
  const [resultsGlobalData, setResultsGlobalData] = useState<undefined | ITableRowData[]>(undefined);
  const [resultsColsGeneratedColors, setResultsColsGeneratedColors] = useState<IAnyString | undefined>(undefined);

  const [lastChangedWidget, setLastChangedWidget] = useState<ITableRowData | undefined>(undefined);
  const [tobeDeselected, setTobeDeselected] = useState<string[]>([]);

  const [unblockInput, setUnblockInput] = useState(false);
  const [selectedRowsData, setSelectedRowsData] = useState<ISelectedRowsData>({ fullData: [], idsOnly: []});
  const [lock, setLock] = useState(true);
  const [draggingStarted, setDraggingStarted] = useState(false);
  const [modal, setModal] = useState(false);
  const [filterByVal, setFilterByVal] = useState("");
  const [lastSelectedPicker, setLastSelectedPicker] = useState("");
  const [preview, setPreview] = useState<{ blob: Blob; filename: string } | undefined>();
  const [previewModal, setPreviewModal] = useState(false);

  const [thresholdConfirmModal, setThresholdConfirmModal] = useState<{ show: boolean; pendingIds: string[]; pendingFullData: ITableRowData[] }>({ show: false, pendingIds: [], pendingFullData: [] });

  const [productionModal, setProductionModal] = useState(false);
  const [productionModalData, setProductionModalData] = useState({id: "", state: "", comment: "", last_comment: "", selected_threshold: undefined, dataset_id: ""});

  const [saveTemplateModal, setSaveTemplateModal] = useState({show: false, template: "", template_id: ""});
  const [saveAsNewTemplateModal, setSaveAsNewTemplateModal] = useState({show: false, template: "", template_id: ""});
  
  const [selectedTemplateModal, setSelectedTemplateModal] = useState({template: "", template_id: ""});

  const [selectedModalFilteringOptions, setSelectedModalFilteringOptions] = useState<string[]>([]);
  const [modalData, setModalData] = useState<ITableRowData>({id : "", selectedThreshold: undefined, customColumnsColors: {}, tabWidgetId: "", mainLayoutParent: [], selectedStepId: "", steps: [], name: "", textType: "", text: "", widget_type: "", source: "", selectedColumns: []});
  const [layout, setLayout] = useState<IConfig[]>([]);
  const [layoutItems, setlayoutItems] = useState<IBlock[]>([]);
  const [generatedDefaultLayout, setGeneratedDefaultLayout] = useState<ILayout>({layout: [], layoutItems: [], lock: false});

  const [pdfLayout, setPdfLayout] = useState<IConfig[]>([]);
  const [pdfLayoutItems, setPdflayoutItems] = useState<IBlock[]>([]);

  const [isDirty, setIsDirty] = useState(false);
  const [isBackDirty, setIsBackDirty] = useState(false);
  const [gridTabsDefault, setGridTabsDefault] = useState(false);
  const { flag, setFlag, next } = usePrompt(isDirty);

  const [selectedModelConfigColumns, setSelectedModelConfigColumns] = useState<{key: string; displayName: string}[]>([]);
  const [layoutInstance, setLayoutInstance] = useState<number>(1);

  const authCtx = useContext(AuthContext);
  const params = useParams();
  const navigate = useNavigate();
  
  const { handleBack } = useBack();
  const rolesArray = authCtx.selectedTenant.roles;

  const { sendRequest: postGeneratePdf, status: generatePdfStatusPost, data: generatePdfData, error: generatePdfErrorPost } = useHttpNonTable(postSingleNonTable, false, authCtx.token, "pdf", "analytics");
  const { sendRequest: postGeneratePdfPreview, status: generatePdfPreviewStatusPost, data: generatePdfPreviewData, error: generatePdfPreviewErrorPost } = useHttpNonTable(postSingleNonTable, false, authCtx.token, "pdf", "analytics");
  const { sendRequest: getPdfTemplate, status: pdfTemplateStatusGet, data: pdfTemplateData, error: pdfTemplateErrorGet } = useHttp(getAllData, false, authCtx.token, "layout", "analytics");
  
  const { sendRequest: getReportDetails, status: reportDetailsStatus, data: reportDetailsData, error: reportDetailsError } = useHttpNonTable(getAllDataNonTable, false, authCtx.token, "report", "analytics");
  const { sendRequest: getModelData, status: modelDataStatus, data: modelData, error: modelDataErrorGet } = useHttpNonTable(getAllDataNonTable, false, authCtx.token, undefined, "analytics");
  const { sendRequest: getSourceData, status: sourceDataStatus, data: sourceData, error: sourceDataErrorGet } = useHttpNonTable(getAllDataNonTable, false, authCtx.token, undefined, "analytics");
  const { sendRequest: getDownloadModel, status: getDownloadModelStatus, data: getDownloadModelData, error: getDownloadModelError } = useHttpNonTable(getAllDataNonTable, false, authCtx.token, "model", "analytics");

  const { sendRequest: getHistoryCols, status: getHistoryColsStatus, data: getHistoryColsData} = useHttp(getAllData, false, authCtx.token, undefined, "analytics");

  const { sendRequest: getResultsCols, status: getResultsColsStatus, data: getResultsColsData} = useHttp(getAllData, false, authCtx.token, undefined, "analytics");
  const { sendRequest: getTemplateLayouts, status: getTemplateLayoutsStatus, data: getTemplateLayoutsData} = useHttp(getAllData, false, authCtx.token, undefined, "analytics");

  const { sendRequest: getTemplateLayout, status: getTemplateLayoutStatus, data: getTemplateLayoutData, error: getTemplateLayoutStatusError} = useHttp(getAllData, false, authCtx.token, "layout", "analytics");
  const { sendRequest: postTemplateLayout, status: postTemplateLayoutStatus, data: postTemplateLayoutData, error: postTemplateLayoutErrorr} = useHttp(postSingleNonTable, false, authCtx.token, "layout",  "analytics");
  const { sendRequest: postSelectTemplateLayout, status: postSelectTemplateLayoutStatus, error: postSelectTemplateLayoutError } = useHttp(postSingleNonTable, false, authCtx.token, undefined, "analytics");
  const { sendRequest: postSendToProduction, status: postSendToProductionStatus, error: postSendToProductionError, data: postSendToProductionData } = useHttp(postSingleNonTable, false, authCtx.token, undefined, "analytics");
  const { sendRequest: postReportDetails, status: postReportDetailsStatus, data: postReportDetailsData, error: postReportDetailsError } = useHttp(postSingleNonTable, false, authCtx.token, "report", "analytics");

  const { sendRequest: getResultDataByCols, status: getResultDataByColsStatus, error: getResultDataByColsError, data: getResultDataByColsData } = useHttp(postSingleNonTable, false, authCtx.token, undefined, "analytics");

  const chartRef = useRef<ChartJS<"line", number[], string>>(null);

  const [modalState, setModalState] = useState<IModalState>({
    isOpen: false,
    rowId: undefined,
  });

  const onBackClick = () => {
    if (isDirty) {
      setIsBackDirty(true);
      setModalState({ isOpen: true, rowId: undefined });
    } else {
      handleBack();
    }
  };

  useEffect(() => {
    if (getHistoryColsStatus === "completed" && getHistoryColsData) {
      setHistoryDataColsWithLabels(getHistoryColsData.rows.columns);
      const prepareReportHistoryData = [];
      for (const [key, value] of Object.entries(getHistoryColsData.rows.columns)) {
        prepareReportHistoryData.push({name: typeof value === "string"? value : "", id: key});
      }
      setHistoryDataColsWithLabelsTransformed(prepareReportHistoryData);
    }
  }, [getHistoryColsStatus]);

  useEffect(() => {
    const localStorageToBecleanedUp = { ...localStorage };
    delete localStorageToBecleanedUp["expirationTime"];
    delete localStorageToBecleanedUp["roles"];
    delete localStorageToBecleanedUp["selected_tenant"];
    delete localStorageToBecleanedUp["selected_tenant_id"];
    delete localStorageToBecleanedUp["token"];
    delete localStorageToBecleanedUp["userId"];

    for (const [key] of Object.entries(localStorageToBecleanedUp)) {
      key && localStorage.removeItem(key);
    }
  }, []);

  useEffect(() => {
    if(postTemplateLayoutStatus === "completed"){
      postSelectTemplateLayout(`select_template_layout/${reportDetailsData.dataset_id}/analytics_report_template`,{
        selected_template_layout_id: postTemplateLayoutData.id}
        , undefined, "none");
      setSaveTemplateModal({show: false, template: "", template_id: ""});
    }
  }, [postTemplateLayoutStatus, ]);

  useEffect(() => {
    if (getResultDataByColsStatus === "completed" && !getResultDataByColsError && getResultDataByColsData) {
      const result = getResultDataByColsData.map((resData:ITableRowData, i:number) => {
        if (!resultsGlobalData) {
          return {...resData, id: resData.threshold};
        } else {
          return {...resData, ...resultsGlobalData[i], id: resData.threshold};
        }
      });
      setResultsGlobalData(result);

      const colorsResult:IAnyString = {};
      resultSelectedUniqueCols?.forEach((colKey:string) => {
        colorsResult[colKey] = resultsColsGeneratedColors && resultsColsGeneratedColors[colKey] !== undefined? resultsColsGeneratedColors[colKey] : randomHexColorCode();
      });
      setResultsColsGeneratedColors(colorsResult);
    }
  }, [getResultDataByColsStatus]);

  useEffect(() => {
    if (postSelectTemplateLayoutStatus === "completed" && !postSelectTemplateLayoutError) {
      setIsDirty(false);
      next();
    }
  }, [postSelectTemplateLayoutStatus]);

  useEffect(() => {
    if (postSendToProductionStatus === "completed" && !postSendToProductionError) {
      setProductionModalData({...productionModalData, comment: "", last_comment: postSendToProductionData.comment});
      setProductionModal(false);
    }
  }, [postSendToProductionStatus]);

  useEffect(() => {
    setGeneratedDefaultLayout(defaultLayout());
    getReportDetails(`report/${params.id}`, undefined, undefined, "none");
    getResultsCols(`report_data_columns/${params.id}`, undefined, undefined, "none");
    getHistoryCols(`history_trend_columns/${params.id}`, undefined, undefined, "none");
  }, []);

  useEffect(() => {
    if (rolesArray.indexOf(roleWrite) !== -1) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    if (getTemplateLayoutStatus === "completed" && !getTemplateLayoutStatusError)   {
      setIsDirty(false);
      if (!isDirty && isBackDirty) {
        handleBack();
      }
    }
  }, [getTemplateLayoutStatus]);

  useEffect(() => {
    if (getTemplateLayoutStatus === "completed" && !getTemplateLayoutStatusError && layout.length === 0 && layoutItems.length === 0) {
      setlayoutItems(getTemplateLayoutData.layout.layoutItems);
      setLayout(getTemplateLayoutData.layout.layout);
    }
  }, [getTemplateLayoutStatus, layoutItems, layout]);

  useEffect(() => {
    if (getTemplateLayoutStatus === "completed" && !getTemplateLayoutStatusError) {
      if ("layoutItems" in getTemplateLayoutData.layout && "layout" in getTemplateLayoutData.layout) {
        // empty the Grid state before transferring a layout 
        setlayoutItems([]);
        setLayout([]);
      }
    }
  }, [getTemplateLayoutStatus]);

  useEffect(() => {
    if (selectedTemplateModal.template_id) {
      getTemplateLayout(`template_layout/${selectedTemplateModal.template_id}`, undefined, undefined,  "Template selected successfully");
    }
  }, [selectedTemplateModal.template_id]);

  useEffect(() => {
    if (postTemplateLayoutStatus === "completed" && !postTemplateLayoutErrorr && reportDetailsData.dataset_id && unblockInput) {
      postSelectTemplateLayout(`select_template_layout/${reportDetailsData.dataset_id}/analytics_report_template`,{
        selected_template_layout_id: postTemplateLayoutData.id}, undefined, "none");
      setSaveTemplateModal({show: false, template: "", template_id: ""});
    }
  }, [postTemplateLayoutStatus, unblockInput]);

  const CustomModal: React.FC<ICustomModalProps> = ({
    show,
    title,
    children,
  }) => {
    const processedTemplateId = useRef<string | null>(null);

    useEffect(() => {
      if (
        show && 
        reportDetailsData?.selected_template_layout_id && processedTemplateId.current &&
        processedTemplateId.current !== reportDetailsData.selected_template_layout_id
      ) {
        getTemplateLayout(
          `template_layout/${reportDetailsData.selected_template_layout_id}`,
          undefined,
          undefined
        );
        processedTemplateId.current = reportDetailsData.selected_template_layout_id;
      }
    }, [show, reportDetailsData?.selected_template_layout_id, getTemplateLayoutStatus]);

    return (
      <div className="modal show d-block save-modal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
               Save changes on template: {getTemplateLayoutData?.name ? `${getTemplateLayoutData.name}` : title}
              </h5>
              <button type="button" className="btn-close" onClick={() => {
                setModalState({
                  isOpen: false,
                  rowId: undefined,
                });
                setFlag(false);
              }}
              >

              </button>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              {getTemplateLayoutData?.is_global || getTemplateLayoutData?.sygno_default ? 
                <button type="button" className="btn btn-danger" onClick={handleDiscard}>Discard</button> :
                <Fragment>
                  <button type="button" className="btn btn-primary" onClick={() => saveLayoutHandler(getTemplateLayoutData)}>Save</button>
                  <button type="button" className="btn btn-danger" onClick={handleDiscard}>
                  Discard
                  </button>
                </Fragment>
              }
              <button
                type="button"
                className="btn btn-save-new"
                onClick={() => {
                  setSaveAsNewTemplateModal({ ...saveAsNewTemplateModal, show: true });
                }}
              >
                Save as new template
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (reportDetailsStatus === "completed" && !reportDetailsError && reportDetailsData) {
      getPdfTemplate(`template_layout/${reportDetailsData.selected_pdf_template_layout_id}`);
      setProductionModalData({
        ...reportDetailsData,
        id: reportDetailsData.user_id,
        // we check the difference between "pending_production_approval" and "production" only on POST
        state: reportDetailsData.state === "pending_production_approval"? "production" : reportDetailsData.state,
        last_comment: reportDetailsData.comment? reportDetailsData.comment : "",
      });

      if (!reportDetailsData.selected_template_layout_id) {
        setLayout(generatedDefaultLayout.layout);
        setlayoutItems(generatedDefaultLayout.layoutItems);
        setLock(true);
      } else {
        setLayout(reportDetailsData.selected_template_layout.layout);
        setlayoutItems(reportDetailsData.selected_template_layout.layoutItems);
        setLock(reportDetailsData.selected_template_layout.lock);
      }
    }
  }, [reportDetailsStatus]);

  useEffect(() => {
    if (pdfTemplateStatusGet === "completed" && !pdfTemplateErrorGet) {
      if ("layoutItems" in pdfTemplateData.layout && "layout" in pdfTemplateData.layout) {
        setPdfLayout(pdfTemplateData.layout.layout);
        setPdflayoutItems(pdfTemplateData.layout.layoutItems);
      }
    }
  }, [pdfTemplateStatusGet]);

  useEffect(() => {
    unblockInput && getTemplateLayouts("template_layouts/analytics_report_template", undefined, undefined, "none");
  }, [unblockInput]);

  useEffect(() => {
    if (generatePdfPreviewStatusPost === "completed" && !generatePdfPreviewErrorPost && generatePdfPreviewData) {
      setPreview(generatePdfPreviewData);
    }
  }, [generatePdfPreviewStatusPost]);

  useEffect(() => {
    if (generatePdfStatusPost === "completed" && !generatePdfErrorPost && generatePdfData) {
      const url = window.URL.createObjectURL(generatePdfData.blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", generatePdfData.filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }, [generatePdfStatusPost]);

  useEffect(() => {
    if (getDownloadModelStatus === "completed" && !getDownloadModelError && getDownloadModelData) {
      const url = window.URL.createObjectURL(getDownloadModelData);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "model.sql");
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }, [getDownloadModelStatus]);

  useEffect(() => {
    if (getResultsColsStatus === "completed" && getResultsColsData) {
      setResultDataColsWithLabels(getResultsColsData.rows.columns);

      const prepareReportResultsData = [];
      for (const [key, value] of Object.entries(getResultsColsData.rows.columns)) {
        prepareReportResultsData.push({name: typeof value === "string"? value : "", id: key});
      }
      setResultDataColsWithLabelsTransformed(prepareReportResultsData);
    }
  }, [getResultsColsStatus]);

  useEffect(() => {
    if (getResultDataByColsStatus === "completed" && !modelDataErrorGet && resultsGlobalData && getResultDataByColsData && getResultsColsStatus === "completed" && getResultsColsData) {
      const getResults:IChartResultsCols = populateResultsObj(resultsGlobalData, getResultsColsData);
      setResultChartData(getResults);
    }
  }, [getResultDataByColsStatus, getResultsColsStatus, resultsGlobalData]);

  useEffect(() => {
    if (sourceDataStatus === "completed" && !sourceDataErrorGet && sourceData) {
      const extractedKeys = extractKeyFromDataObj(sourceData,"sourceDataKeysExtr");
      setExtKeys({...extKeys, ...extractedKeys});
    }
  }, [sourceDataStatus]);

  useEffect(() => {
    let resultToBeFetch = false;
    let modelToBeFetch = false;
    let sourceDataToBeFetch = false;
    let allCollsResult:string[] = [];

    layoutItems.forEach((item) => {
      if (item.optionName === "Model Configuration") {
        if (item.settings?.source === "model") {
          modelToBeFetch = true;
        }
      }
      else if (item.optionName === "Tabs Widget" && item.steps.length !== 0) {
        item.steps.forEach((step) => {
          step.layoutItems.forEach((item) => {
            if (item.settings?.source === "report_data") {
              allCollsResult = [...allCollsResult, ...item.settings.selectedColumns];
              resultToBeFetch = true;
            }
            if (item.settings?.source === "model") {
              modelToBeFetch = true;
            }
            if (item.settings?.source === "source_data") {
              sourceDataToBeFetch = true;
            }
          });
        });
      }
    });

    if (getResultDataByColsStatus !== "pending" && (resultDataColsWithLabelsTransformed || resultToBeFetch)) {
      allCollsResult = allCollsResult.filter(onlyUnique);
      // "threshold" is a fixed col, so we want to ignore it in the general flow
      allCollsResult = allCollsResult.filter(colData => colData !== "threshold");
      setResultSelectedUniqueCols(allCollsResult);

      if (getResultDataByColsData && resultSelectedUniqueCols && lastChangedWidget?.widgetType !== "table") {
        const newlyAddedMetricsOnly = allCollsResult.filter(x => !resultSelectedUniqueCols.includes(x));
        newlyAddedMetricsOnly.length !== 0 && 
        getResultDataByCols(`report_data/${params.id}`, {
          columns: newlyAddedMetricsOnly.filter((colll) => getResultsColsData?.rows?.columns[`${colll}`])
        }, undefined, "none");
      } else if (!getResultDataByColsData && getResultsColsData) {
        // table
        getResultDataByCols(`report_data/${params.id}?order_by=threshold asc`, {
          columns: allCollsResult.filter((colll) => getResultsColsData?.rows?.columns[`${colll}`])
        }, undefined, "none");
      }
    }

    if (modelDataStatus !== "pending" && ((modalData.source === "model" && extKeys.modelKeysExtr.length === 0) || (modelToBeFetch && !modelData))) {
      getModelData(`model/${params.id}`, "?order_by=technical_variable_name asc", undefined, "none");
    }
    if (sourceDataStatus !== "pending" && ((modalData.source === "source_data" && extKeys.modelKeysExtr.length === 0) || (sourceDataToBeFetch && !sourceData))) {
      getSourceData(`source_data/${params.id}`, undefined, undefined, "none");
    }
  }, [modalData.source, layoutItems, lastChangedWidget, getResultsColsData]);

  useEffect(() => {
    if (selectedRowsData.idsOnly.length > 0) {
      let updatedListOfToBeDeleted = [...tobeDeselected];

      selectedRowsData.fullData.forEach((selectedRowData:ITableRowData) => {
        if (tobeDeselected.indexOf(selectedRowData.threshold) !== -1) {
          updatedListOfToBeDeleted = updatedListOfToBeDeleted.filter((selectedId:string) => selectedId !== selectedRowData.threshold);
        }
      });
      setTobeDeselected(updatedListOfToBeDeleted);
    }
  }, [selectedRowsData.idsOnly]);

  useEffect(() => {
    if (postReportDetailsStatus === "completed" && !postReportDetailsError && postReportDetailsData) {
      const { pendingIds, pendingFullData } = thresholdConfirmModal;
      setThresholdConfirmModal({ show: false, pendingIds: [], pendingFullData: [] });
      if (pendingIds.length > 0) {
        reportDetailsData.selected_threshold = pendingIds[0]
        setSelectedRowsData({ fullData: pendingFullData, idsOnly: pendingIds });
      }
    }
  }, [postReportDetailsStatus, postReportDetailsError, postReportDetailsData]);

  const handleThresholdChange = (newIds: string[]) => {
    postReportDetails(`report/${params.id}`, {
      id: params.id,
      selected_threshold: parseFloat(newIds[0])
    }, undefined, "Threshold updated successfully");
  };

  const getSelectedRowsData = (newRow: ITableRowData[]) => {
    const newlySelectedId = newRow.filter(row => !selectedRowsData.idsOnly.includes(row.id));
    if (newlySelectedId.length === 0) {
      return;
    }

    const justClicked = newlySelectedId[newlySelectedId.length - 1];
    const newThreshold = justClicked.id;
    const currentThreshold = reportDetailsData?.selected_threshold;

    if (newThreshold === currentThreshold) {
      return;
    }

    setThresholdConfirmModal({ show: true, pendingIds: [justClicked.id], pendingFullData: [justClicked] });
  };

  const defineOptions = (name: string) => {
    const result:any = { // eslint-disable-line
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: "index" as const, intersect: false },
      stacked: false,
      clip: false,
      plugins: {
        title: {
          display: true,
          text: name,
        },
        tooltip: {
          usePointStyle: true,
          callbacks: {
            title: (data: any) => { // eslint-disable-line
              return name === "Results" ? `Threshold: ${data[0].label}` : data[0].label;
            },
            label: function(context:any) { // eslint-disable-line
              let label = context.dataset.label;
              if (label) {
                label += ": ";
              }
              if (context.parsed.y !== null) {
                if (
                  context.dataset.label.includes("Percentage") ||
                  context.dataset.label.includes("ratio")
                ) { 
                  label += rationToPercents2Decimals(context.parsed.y);
                } else {
                  label += context.parsed.y;
                }
              }
              return label;
            }
          }
        }
      },
      scales: {
        y: {
          type: "linear" as const,
          display: true,
          position: "left" as const,
          min: 0
        },
        y1: {
          type: "linear" as const,
          max: 1,
          min: 0,
          ticks: {
            beginAtZero: true,
            count: 11,
            callback: ((value: any) => { // eslint-disable-line
              return rationToPercents2Decimals(value);
            })
          },
          display: true,
          position: "right" as const,
          grid: {
            drawOnChartArea: false,
          },
        },
      },
    };
    if (name === "Results") {
      result.scales["x"] = {
        type: "linear" as const,
        display: true,
        ticks: {
          count: 101,
        },
      };
      const activeThreshold = selectedRowsData.idsOnly.length > 0
        ? parseFloat(selectedRowsData.idsOnly[0])
        : reportDetailsData?.selected_threshold;
      if (activeThreshold !== undefined) {
        result.plugins.annotation = {
          annotations: {
            selectedThresholdLine: {
              type: "line",
              xMin: activeThreshold,
              xMax: activeThreshold,
              borderColor: "rgba(0,0,0,0.7)",
              borderWidth: 2,
              borderDash: [6, 4],
            }
          }
        };
      } else {
        result.plugins.annotation = { annotations: {} };
      }
    }
    return result;
  };

  const handleSubmit = () => {
    let setId = modalData.id;

    const selectedColsWithThresholdCol =
      modalData?.selectedColumns?.indexOf("threshold") === -1 && modalData.widget_type === "table" && modalData.source === "report_data"
        ? ["threshold", ...modalData.selectedColumns]
        : modalData.selectedColumns;
    
    if (modalData.mainLayoutParent.length === 0 && modalData.tabWidgetId === "") {
      if (setId === "") {
      // new main widget
        setId = createUUID();
        setLastChangedWidget({id: setId, widgetType: modalData.widget_type, changed: lastChangedWidget? !lastChangedWidget.changed : true});
        setlayoutItems([
          ...layoutItems,
          {
            optionName: modalData.name,
            id: setId,
            text: modalData.text,
            textType: modalData.textType,
            steps: modalData.steps,
            selectedStepId: modalData.name === "Tabs Widget" ? modalData.steps[0].key : "",
            settings: modalData.name === "Custom widget" ?
              {
                widget_type: modalData.widget_type,
                selectedThreshold: modalData.source !== "history"? undefined : modalData.selectedThreshold,
                source: modalData.source, 
                selectedColumns: selectedColsWithThresholdCol,
                customColumnsColors: modalData.name === "Custom widget"?  (modalData?.customColumnsColors ? {...modalData.customColumnsColors} : {}) : {},
              } 
              : undefined
          },
        ]);
        !lock && setIsDirty(true);
      } else {
      // edit main widgets
        const result = layoutItems.map((item) => {
          if (item.id === setId) {
            return {
              optionName: modalData.name,
              id: setId,
              text: modalData.text,
              textType: modalData.textType,
              steps: modalData.steps,
              selectedStepId: item.selectedStepId,
              settings: modalData.name === "Custom widget" ? 
                {
                  widget_type: modalData.widget_type, 
                  selectedThreshold: modalData.source !== "history"? undefined : modalData.selectedThreshold,
                  source: modalData.source,
                  selectedColumns: modalData.selectedColumns,
                  customColumnsColors: modalData.name === "Custom widget"?  (modalData?.customColumnsColors ? {...modalData.customColumnsColors} : {}) : {},
                } 
                : undefined
            };
          } else {
            return item;
          }
        });

        setLastChangedWidget({id: setId, widgetType: modalData.widget_type, changed: lastChangedWidget? !lastChangedWidget.changed : true});
        setlayoutItems(result);
        !lock && setIsDirty(true);
      }} else {
      // from tabs widget
      const result = layoutItems.map((item) => {
        if (item.id === modalData.tabWidgetId) {
          return {...item, steps: item.steps.map((step:IStep) => {
            if (step.key === item.selectedStepId) {
              let layoutItemsResult = [];
              // add the tab's widget
              if (setId === "") {
                setId = createUUID();
                setLastChangedWidget({id: setId, widgetType: modalData.widget_type, changed: lastChangedWidget? !lastChangedWidget.changed : true});
                layoutItemsResult = [
                  ...step.layoutItems,
                  {
                    optionName: modalData.name,
                    id: setId,
                    text: modalData.text,
                    textType: modalData.textType,
                    steps: [],
                    selectedStepId: modalData.name === "Tabs Widget" ? modalData.steps[0].key : "",
                    settings: modalData.name === "Custom widget" ? 
                      {
                        widget_type: modalData.widget_type, 
                        source: modalData.source , 
                        selectedColumns: selectedColsWithThresholdCol,
                        selectedThreshold: modalData.source !== "history"? undefined : modalData.selectedThreshold,
                        customColumnsColors: modalData?.customColumnsColors ? {...modalData.customColumnsColors} : {},
                      } 
                      : undefined
                  },
                ];
              } else {
                // edit the tab's widget
                layoutItemsResult = step.layoutItems.map((layoutItem:IBlock) => {
                  if (setId === layoutItem.id) {
                    setLastChangedWidget({id: setId, widgetType: modalData.widget_type, changed: lastChangedWidget? !lastChangedWidget.changed : true});
                    return {
                      optionName: modalData.name,
                      text: modalData.text,
                      textType: modalData.textType,
                      id: setId,
                      steps: [],
                      selectedStepId: modalData.selectedStepId,
                      settings: modalData.name === "Custom widget" ? 
                        {
                          widget_type: modalData.widget_type, 
                          source: modalData.source,
                          selectedThreshold: modalData.source !== "history"? undefined : modalData.selectedThreshold,
                          selectedColumns: selectedColsWithThresholdCol,
                          customColumnsColors: modalData?.customColumnsColors ? {...modalData.customColumnsColors} : {},
                        } 
                        : undefined
                    };
                  }
                  return layoutItem;
                });
              }
              return {
                ...step, layoutItems: layoutItemsResult
              };
            }
            return step;
          })
          };}
        else {
          return item;
        }
      });
      setlayoutItems(result);
      !lock && setIsDirty(true);
    }
    setFilterByVal("");
    setModal(false);
    setSelectedModalFilteringOptions([]);
    setModalData({id : "", selectedThreshold: undefined, customColumnsColors: {}, mainLayoutParent: [], tabWidgetId: "", steps: [], name: "", text: "", textType: "", widget_type: "", source: "", selectedColumns: []});
  };

  const handleModalClosed = () => {
    setFilterByVal("");
    setModal(false);
    setSelectedModalFilteringOptions([]);
    setModalData({id : "", selectedThreshold: undefined, customColumnsColors: {}, mainLayoutParent: [], tabWidgetId: "", steps: [], name: "", text: "", textType: "", widget_type: "", source: "", selectedColumns: []});
  };

  const extractKeyFromDataObj = (fetchedData: any, keyName: string) => { // eslint-disable-line
    if (!fetchedData) { return {[keyName]:[]};}
    const fetchedDataKeysExtr = {...fetchedData[0]};
    delete fetchedDataKeysExtr["id"];
    delete fetchedDataKeysExtr["report_id"];
    return { [keyName]: Object.keys(fetchedDataKeysExtr) };
  };

  const onBlockAdd = (name: string, settings: ISettings | undefined) => {
    const newID = createUUID();
    const withNewItem = [
      ...layoutItems,
      {
        optionName: name,
        id: newID,
        settings,
        steps: []
      },
    ];
    setlayoutItems(withNewItem);
    !lock && setIsDirty(true);
  };

  const getNewColumnsOrder = (data: IParentData, order: IColumn[]) => {
    const onlyKeys = order.map((column:IColumn) => column.key);
    if  (data.parentTabsWidgetData.length === 0) {
      const layoutItemsClone:IBlock[] = layoutItems.map((item) => {
        if (item.id === data.widgetId) {
          return {...item, settings: item.settings? {...item.settings, selectedColumns: onlyKeys} : undefined};
        }
        return item;
      });
      setlayoutItems(layoutItemsClone);
      !lock && setIsDirty(true);
    } else {
      // Tabs widget
      const layoutItemsClone:IBlock[] = layoutItems.map((item) => {
        if (item.id === data.parentTabsWidgetData[0].id) {
          return {...item, steps: item.steps.map((step) => {
            if (item.selectedStepId === step.key) {
              return {...step, layoutItems: step.layoutItems.map((layoutItem) => {
                if (data.widgetId === layoutItem.id) {
                  return {...layoutItem, settings: layoutItem.settings? {...layoutItem.settings, selectedColumns: onlyKeys} : undefined};
                }
                return item;
              })};
            }
            return step;
          })};
        }
        return item;
      });
      setlayoutItems(layoutItemsClone);
      !lock && setIsDirty(true);
    }
  };

  const formatModelConfigKey = (key: string) => {
    return modelConfigKeyMapping[key as keyof typeof modelConfigKeyMapping] || key;
  };

  const toDisplayModelConfig = (val: any): string => { // eslint-disable-line
    if (val == null){
      return ""; // Handles null and undefined
    }

    if (typeof val === "string" || typeof val === "number") {
      return convertModelconfigValueToFrontendValue.get(String(val)) || String(val);
    }

    if (typeof val === "boolean") {
      return val ? "Yes" : "No";
    }

    if (Array.isArray(val)) {
      return val.map((item) => toDisplayModelConfig(item)).join(", ");
    }

    if (typeof val === "object") {
      try {
        return JSON.stringify(val);
      } catch {
        return String(val);
      }
    }

    return String(val);
  };
  const renderCustomWidget = (id: string, layoutItemsLoc:IBlock[], layoutLoc:IConfig[], tabsWidgetData?: IBlock[]) => {
    const findIdMatch = layoutItemsLoc.find((item:IBlock) => item.id === id);
    // fallback
    if (!findIdMatch) { 
      return <div>loading...</div>;
    }
    const selectedSource = findIdMatch.settings?.source;
    const selectedType  = findIdMatch.settings?.widget_type;
  
    let modelConfigurationData: any[] = []; // eslint-disable-line
    if (selectedSource === "model_configuration") {
      if (!reportDetailsData?.modelconfig_content) {
        return <div>loading...</div>;
      }
      try {
        const row = JSON.parse(reportDetailsData.modelconfig_content);
        modelConfigurationData = Object.keys(row).map(key => ({
          configurationItem: key,
          value: row[key]
        }));
      } catch (error) {
        console.error("Error parsing model configuration data:", error);
        return <div>Error loading model configuration</div>;
      }
    }
  
    const constructData: any = { // eslint-disable-line
      model: modelData? modelData : [],
      source_data: sourceData? sourceData : [], 
      report_data: resultsGlobalData? resultsGlobalData : [], 
      history: [],
      model_configuration: modelConfigurationData,
    };
  
    let preparedResults = constructData[`${selectedSource}`] ?  [...constructData[`${selectedSource}`]] : undefined;
    if (!preparedResults) {
      return <div className="normalTable-notSupported">This widget is no longer supported</div>;
    }
  
    if (selectedSource === "report_data") {
      const approvedThreshold = selectedRowsData.idsOnly.length > 0
        ? parseFloat(selectedRowsData.idsOnly[0])
        : reportDetailsData?.selected_threshold;
      preparedResults = preparedResults.map(row => {
        return {
          approved: approvedThreshold !== undefined ? (approvedThreshold === row.id ? true : false) : false,
          recommended: reportDetailsData && reportDetailsData.opt_thresh? (reportDetailsData.opt_thresh === row.id? true: false) : false,
          ...transformObjectsFracs(row)
        };
      });
    }
  
    const generatedReportColumns:IColumn[] = resultDataColsWithLabelsTransformed? resultDataColsWithLabelsTransformed.map((locData: ITableRowData) => {
      const findKeyOrConvertKeyIntoName = resultDataColsWithLabels && resultDataColsWithLabels[locData.id]? resultDataColsWithLabels[locData.id] : convertKeyIntoName(locData.id);
      return { key:locData.id, displayName: findKeyOrConvertKeyIntoName, dataType: {type: "text" } };
    }) : [];
    const generatedModelColumns:IColumn[] = extKeys.modelKeysExtr.map((key: string) => { return { key, displayName: convertKeyIntoName(key), dataType: {type: "text" } };});
    const generatedSourceColumns:IColumn[] = extKeys.sourceDataKeysExtr.map((key: string) => { return { key, displayName: convertKeyIntoName(key), dataType: {type: "text" } };});
    
    const generatedModelConfigurationColumns:IColumn[] = selectedSource === "model_configuration" && modelConfigurationData.length > 0 
      ? Object.keys(JSON.parse(reportDetailsData.modelconfig_content)).map((key: string) => { 
        const displayName = convertModelconfigKeyToName.get(key) ?? convertKeyIntoName(key);
        return { key, displayName, dataType: {type: "text" } };
      })
      : [];
    
    const generatedHistoryColumns:IColumn[] = historyDataColsWithLabelsTransformed? historyDataColsWithLabelsTransformed.map((locData: ITableRowData) => {
      const findKeyOrConvertKeyIntoName = historyDataColsWithLabels && historyDataColsWithLabels[locData.id]? historyDataColsWithLabels[locData.id] : convertKeyIntoName(locData.id);
      return { key:locData.id, displayName: findKeyOrConvertKeyIntoName, dataType: {type: "text" } };
    }) : [];
  
    let sortingSettings = undefined;
  
    if (id && localStorage.getItem(id) !== "undefined" && localStorage.getItem(id)) {
      const updatedData:string | null | undefined = localStorage.getItem(id);
      sortingSettings =  updatedData?.split("=")?.pop()?.split(" ")[0];
    }
  
    const allColumnsWithIds = [
      { columns: generatedReportColumns, source: "report_data", defaultSorting: sortingSettings? sortingSettings : "threshold"},
      { columns: generatedModelColumns, source: "model", defaultSorting: sortingSettings? sortingSettings: "technical_variable_name"},
      { columns: generatedSourceColumns, source: "source_data", defaultSorting: sortingSettings? sortingSettings : ""},
      { columns: generatedHistoryColumns, source: "history", defaultSorting: sortingSettings? sortingSettings : "timeframe"},
      { columns: generatedModelConfigurationColumns, source: "model_configuration", defaultSorting: sortingSettings? sortingSettings : "configurationItem"}
    ];
  
    const matchSourceWithColumns = allColumnsWithIds.filter((data) => data.source === selectedSource);
    const onlySelectedColumns = matchSourceWithColumns[0].columns.filter((col:IColumn) => findIdMatch.settings?.selectedColumns.indexOf(col.key) !== -1);
  
    const orderAccordingToRemote:IColumn[] | undefined = findIdMatch.settings?.selectedColumns.map((col:string) => {
      if (findIdMatch.settings?.source === "report_data") {
        const findKeyOrConvertKeyIntoName = resultDataColsWithLabels && resultDataColsWithLabels[col]? resultDataColsWithLabels[col] : convertKeyIntoName(col);
        return { key: col, displayName: findKeyOrConvertKeyIntoName, dataType: {type: "text" } };
      } else if (findIdMatch.settings?.source === "model_configuration") {
        const displayName = convertModelconfigKeyToName.get(col) ?? convertKeyIntoName(col);
        return { key: col, displayName, dataType: {type: "text" } };
      } else {
        return { key: col, displayName: convertKeyIntoName(col), dataType: {type: "text" } };
      }
    });
  
    const findScaleinLayout = layoutLoc.filter((block:IConfig) => block.i === id);
    
    if (selectedType === "table") {
      let defineAllColsOfSource:any = {}; // eslint-disable-line
  
      if (findIdMatch.settings?.source === "model" || findIdMatch.settings?.source === "source_data") {
        defineAllColsOfSource = matchSourceWithColumns[0].columns.forEach((colData) => {
          defineAllColsOfSource = {...defineAllColsOfSource, [`${colData.key}`] : colData.displayName};
        });
      } else if (findIdMatch.settings?.source === "model_configuration") {
        defineAllColsOfSource = {};
        matchSourceWithColumns[0].columns.forEach((colData) => {
          defineAllColsOfSource = {...defineAllColsOfSource, [`${colData.key}`] : colData.displayName};
        });
      } else if (findIdMatch.settings?.source === "report_data")  {
        defineAllColsOfSource = getResultsColsData?.rows?.columns;
        if (!getResultsColsData) {
          return;
        }
      } else if (findIdMatch.settings?.source === "history") {
        defineAllColsOfSource = getHistoryColsData?.rows?.columns;
        if (!getHistoryColsData) {
          return;
        }
      }
  
      if (selectedSource === "model_configuration") {
        const selectedColumns = orderAccordingToRemote ? orderAccordingToRemote : onlySelectedColumns;
        const rowData = JSON.parse(reportDetailsData.modelconfig_content);
        
        return (
          <div className="reportDetailsClassic-modelConfigTableWrapper" style={{height: `${findScaleinLayout.length !== 0 ?  ((findScaleinLayout[0].h * 25 ) - 10) : 180}px`, overflow: 'auto'}}>
            <table className="reportDetailsClassic-modelConfigTable">
              <thead className="reportDetailsClassic-modelConfigTableThead">
                <tr className="reportDetailsClassic-modelConfigTableTheadTr">
                  <th className="reportDetailsClassic-modelConfigTableTheadTh">Configuration Item</th>
                  <th className="reportDetailsClassic-modelConfigTableTheadTh">Value</th>
                </tr>
              </thead>
              <tbody className="reportDetailsClassic-modelConfigTableTbody">
                {selectedColumns.map(({ key }) => {
                  const value = rowData[key];
                  // skip if value is null, undefined, or empty string
                  if (value === null || value === undefined || value === "") {
                    return null;
                  }
  
                  const isBool = typeof value === "boolean";
                  const display = isBool ? "" : toDisplayModelConfig(value);
  
                  return (
                    <tr className="reportDetailsClassic-modelConfigTableTbodyTr" key={key}>
                      <td className="reportDetailsClassic-modelConfigTableTbodyTd">
                        {formatModelConfigKey(key)}
                      </td>
                      <td className="reportDetailsClassic-modelConfigTableTbodyTd">
                        {isBool ? (value ? <FaCheck /> : <FaTimes />) : display}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      }
  
      return (
        <NormalTableHoc
          orderSettings={{parentTabsWidgetData: tabsWidgetData? tabsWidgetData : [], widgetId: id}}
          draggingStarted={draggingStarted}
          statusFields={{approved_id: selectedRowsData.idsOnly.length > 0 ? parseFloat(selectedRowsData.idsOnly[0]) : reportDetailsData?.selected_threshold}}
          getDraggingStatus={(toggle: boolean) => setDraggingStarted(toggle)}
          selectedSource={selectedSource}
          columns={orderAccordingToRemote ? orderAccordingToRemote : onlySelectedColumns}
          allColumns={defineAllColsOfSource}
          fetchedData={{ rows: preparedResults }}
          lock={lock}
          widgetData={findIdMatch}
          selectedThreshold={findIdMatch?.settings?.selectedThreshold}
          getNewColumnsOrder={getNewColumnsOrder}
          allStatus="completed"
          dataUrl={"reports/:id"}
          widgetId={findIdMatch?.id}
          tobeDeselected={tobeDeselected}
          lastChangedWidget={lastChangedWidget}
          initiallySelectedRowsIds={selectedRowsData.idsOnly}
          defaultSortCol={matchSourceWithColumns[0].defaultSorting}
          hideSearchInput={true}
          getResultDataByColsStatus={getResultDataByColsStatus}
          hideCheckBoxes={selectedSource === "report_data" ? (rolesArray.indexOf(roleRead) !== -1 && rolesArray.length === 1 ? true : false) :  true}
          getSelectedRowsData={selectedSource === "report_data"? getSelectedRowsData : () => {/**/}}
          unblockInput={unblockInput}
          clickRowToSelectMode={selectedSource === "report_data"? (rolesArray.indexOf(roleRead) !== -1 && rolesArray.length === 1 ? false : true) :  false}
          hideButtons={[]}
          scale={{height: `${findScaleinLayout.length !== 0 ?  ((findScaleinLayout[0].h * 25 ) - 10) : 180}`, width: "auto"}}
        /> 
      );
    }
  
    const resultDataPrep = {...resultChartData, datasets: resultChartData.datasets.filter((dataset) => findIdMatch.settings?.selectedColumns.indexOf(dataset.key) !== -1)};
    
    const applySelectedColor = (data: IMultyChart) => {
      return {
        ...data,
        datasets: data.datasets.map((col:IChartDataset) => {
          const findSelectedColor = findIdMatch.settings?.customColumnsColors?.[col.key];
          const colorResult = findSelectedColor? findSelectedColor : col.backgroundColor;
          return {...col, backgroundColor: colorResult, borderColor: colorResult};
        })
      };
    };

    const onClick = () => {
      const cutString = chartRef.current && chartRef.current.tooltip?.title[0].replace("Threshold: ","");
      if (!cutString) {
        return;
      }
      
      const pendingFullData = resultsGlobalData?.filter(d => d.threshold.toString() === cutString) || [];

      setThresholdConfirmModal({ show: true, pendingIds: [cutString], pendingFullData });
    };
  
    if (selectedType === "chart" && selectedSource === "history" && getHistoryColsData) {
      return <ChartHoc allHistoryCols={getHistoryColsData}  widgetData={findIdMatch} options={defineOptions("History trends")} applySelectedColor={applySelectedColor} />;
    }
  
    if (selectedType === "chart" && selectedSource === "report_data") {
      return (
        <div className="reportDetailsClassic-chart show">
          <Line ref={chartRef} onClick={onClick} options={defineOptions("Results")} data={applySelectedColor(resultDataPrep)} />
        </div>
      );
    }
  };
  const renderWizard = (id: string) => {
    const findIdMatch = layoutItems.filter((item) => item.id === id);
    if (!findIdMatch[0]) { 
      return <div>loading...</div>;
    }
    const selectedTabIndex = findIdMatch[0].steps.findIndex((step:IStep) => step.key === findIdMatch[0].selectedStepId);
    const selectedTabData = selectedTabIndex !== -1? findIdMatch[0].steps[selectedTabIndex] : findIdMatch[0].steps[0];
    const constructTabs = () => findIdMatch[0].steps.map((step:IStep, i: number) => (
      {
        index: i+1,
        stepName: step.name,
        id: step.key,
        fields: [],
      }
    ));
  
    const getLayoutChangesWizard = (layoutLoc: IConfig[]) => {
      let result = [...layoutItems];
      result = result.map((item) => {
        if (findIdMatch[0].id === item.id) {
          return {
            ...item,
            steps: item.steps.map((step:IStep) => {
              if (findIdMatch[0].selectedStepId === step.key) {
                return {
                  ...step,
                  layout: layoutLoc
                };
              }
              return step;
            })
          };
        }
        return item;
      });
      setlayoutItems(result);

      if (!gridTabsDefault) {
        setGridTabsDefault(true);
      } else {
        !lock && setIsDirty(true);
      }
    };

    const getLayoutItemsWizard = (layoutItemsLoc: IBlock[], i: string) => {
      let result = [...layoutItems];
      result = result.map((item) => {
        if (findIdMatch[0].id === item.id) {
          return {
            ...item,
            steps: item.steps.map((step:IStep) => {
              if (findIdMatch[0].selectedStepId === step.key) {
                return {
                  ...step,
                  layoutItems: layoutItemsLoc,
                  layout: selectedTabData.layout.filter((item:IConfig) => item.i !== i)
                };
              }
              return step;
            })
          };
        }
        return item;
      });
      setlayoutItems(result);
      setIsDirty(true);
    };

    const renderTabsWidget = () => {
      return (
        <WidgetsLayout
          layout={selectedTabData ? selectedTabData.layout : []} 
          layoutItems={selectedTabData ? selectedTabData.layoutItems : []}
          mainLayoutParent={findIdMatch}
          getLayoutChanges={getLayoutChangesWizard}
          getLayoutItems={getLayoutItemsWizard}
          optionsBlocks={optionsBlocks}
          lock={lock}
          setModal={setModal}
          setModalDataFromBlock={setModalDataFromBlock}
          unblockInput={unblockInput}
          tabsWidget={true}
          key={selectedTabIndex}
        />
      );
    };

    return (
      <Wizzard
        isFullscreen={true}
        noNumeration={true}
        allowedTabs={findIdMatch[0].steps.map((step:IStep, i:number) => i+1)}
        selectedTabFromParent={selectedTabIndex !== -1? selectedTabIndex+1 : 1}
        getSelectedTab={(tab:number, tabId?: string) => setlayoutItems(layoutItems.map((item) => item.id === id? {...item, selectedStepId: tabId } : item))}
        data={constructTabs()}
      >
        {renderTabsWidget()}
      </Wizzard>
    );
  };

  const renderText = (id: string, layoutItemsLoc : IBlock[]) => {
    const findIdMatch:IBlock | undefined = layoutItemsLoc?.find((item:IBlock) => item.id === id);
    if (!findIdMatch) { 
      return <div>loading...</div>;
    }
    if (findIdMatch.textType === "text") {
      return <p className="reportDetails-labelWrapper">{findIdMatch.text}</p>;
    } else if (findIdMatch.textType === "header") {
      return <h2 className="reportDetails-labelWrapper">{findIdMatch.text}</h2>;
    }
  };

  const optionsBlocks = [
    {
      name: "Text",
      displayName: "Text",
      component: renderText,
      settings: undefined,
      editable: true
    },
    {
      name: "Tabs Widget",
      displayName: "Tabs widget",
      component: renderWizard,
      settings: undefined,
      editable: true
    },
    {
      name: "Custom widget",
      displayName: "Add widget",
      component: renderCustomWidget,
      settings: undefined,
      editable: true
    }
  ];

  const getLayoutChanges = (layout: IConfig[]) => {
    setLayout(layout);
    if (reportDetailsData.selected_template_layout && (JSON.stringify(layout) !== JSON.stringify(reportDetailsData.selected_template_layout.layout))) {
      setIsDirty(true);
    }
  };

  const saveLayoutHandler = (row: any) => { // eslint-disable-line
    if (!reportDetailsData.selected_template_layout_id && !row) {
      setSaveTemplateModal({...saveTemplateModal, show: true});
    } else {
      const defineId = reportDetailsData.selected_template_layout_id ? reportDetailsData.selected_template_layout_id : "";
      if (row?.id) {
        postTemplateLayout(`template_layout/${row.id}`, 
          {id: row.id, 
            name: row.name, 
            layout: JSON.stringify({layout: layout, layoutItems: layoutItems, lock: true }),
            archived: false,
            is_installation: row.is_installation,
            is_global:row.is_global,
            tenant_default: row.tenant_default,
            process: "report",
            template_type: "analytics_report_template"
          }, undefined,  "none");
        postSelectTemplateLayout(`select_template_layout/${reportDetailsData.dataset_id}/analytics_report_template`,{
          selected_template_layout_id: defineId
        }, undefined, "none");
        setModalState({
          isOpen: false,
          rowId: undefined,
        });
      }}
  };

  const handleOnSelectColumnColor = (key: string, color: string, defaultColor?: undefined | string) => {
    setModalData({...modalData, customColumnsColors: { ...modalData.customColumnsColors, [key] : color? color : defaultColor }});
  };

  const handleOnSelectColumn = (key: string) => {
    let result = [...modalData.selectedColumns];
    if (result.indexOf(key) === -1) {
      // check if ever keys existed resultsColsGeneratedColors
      if (resultsColsGeneratedColors && !resultsColsGeneratedColors[key]) {
        setResultsColsGeneratedColors({...resultsColsGeneratedColors, [key] : randomHexColorCode()});
      }
      result = [...result, key];
    } else {
      result = result.filter((selectedKey) => selectedKey !== key);
    }
    setModalData({...modalData, selectedColumns: result});
  };

  const sortWidgetButtons = (columns: IBtnOption[]) => {
    return columns.sort((a, b) => a.id.localeCompare(b.id));
  };

  const onModalClickHandler = (event: React.MouseEvent<HTMLElement>) => {
    const filteredId = (event.target as Element).id.replace("arrow-","");

    if (filteredId !== lastSelectedPicker &&  lastSelectedPicker) {
      setLastSelectedPicker(filteredId);
    }
    else if (filteredId !== lastSelectedPicker && (event.target as Element).className !== "react-colorful__interactive" && lastSelectedPicker !== "") {
      setLastSelectedPicker("");
    }
  };


  const widgetColumnsBtns = (source?: string, mode?: string) => {
    if (
      source === "report_data" && !getResultDataByColsData && !resultDataColsWithLabelsTransformed ||
      source === "model" && !modelData ||
      source === "source_data" && !sourceData ||
      source === "history" && !getHistoryColsData && !historyDataColsWithLabelsTransformed ||
      source === "model_configuration" && !reportDetailsData?.modelconfig_content
    ) {
      return "";
    } 
  
    // Handle model_configuration case
    let modelConfigColumns: IBtnOption[] = [];
    if (source === "model_configuration") {
      try {
        const row = JSON.parse(reportDetailsData.modelconfig_content);
        modelConfigColumns = Object.keys(row).map((key: string) => ({
          id: key,
          name: convertModelconfigKeyToName.get(key) ?? key,
        }));
      } catch (error) {
        console.error("Error parsing model configuration data:", error);
        return "";
      }
    }
  
    // match it with human readable values stored locally, if no match is found then use the key itself
    const result = {
      resultKeysExtr: resultDataColsWithLabelsTransformed? resultDataColsWithLabelsTransformed : [],
      historyKeysExtr: historyDataColsWithLabelsTransformed? historyDataColsWithLabelsTransformed : [],
      crossValidationKeysExtr: sortWidgetButtons(extKeys.crossValidationKeysExtr.map((key:string) => {
        const result = crossValidationKeys.find((resKey) => resKey.id === key);
        return result ? result : {name: key, id: key};
      })),
      modelKeysExtr: sortWidgetButtons(extKeys.modelKeysExtr.map((key:string) => {
        const result = modelKeys.find((resKey) => resKey.id === key);
        return result ? result : {name: key, id: key} ;
      })),
      sourceDataKeysExtr: sortWidgetButtons(extKeys.sourceDataKeysExtr.map((key:string) => {
        const result = sourceDataKeys.find((resKey) => resKey.id === key); 
        return result ? result : {name: key, id: key};
      })),
      modelConfigKeysExtr: sortWidgetButtons(modelConfigColumns)
    };
  
    if (source === "report_data") {
      if (modalData.widget_type === "chart"){
        // chart
        // we display threshhold as x-axis
        let filteredResult:IBtnOption[] = [];
  
        if (mode === "onlySelected") {
          result.resultKeysExtr.forEach((col:IBtnOption) => {
            if (col.id !== "threshold") {
              if (modalData.selectedColumns.indexOf(col.id) !== -1) {
                filteredResult.push(col);
              }
            } 
          });
        } else {
          result.resultKeysExtr.forEach((col:IBtnOption) => {
            if (col.id !== "threshold") {
              let matched = false;
              selectedModalFilteringOptions.forEach((selectedOption) => {
                if (!col.id.includes(selectedOption)) {
                  matched = true;
                } 
              });
              if (!matched) {
                filteredResult.push(col);
              }
            } 
          });
          filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
        }
        return filteredResult.map((key:IBtnOption) => {
          return (
            <CustomCheckbox
              withInnerHeight={"#modalInputsWrapper"}
              lastSelectedPicker={lastSelectedPicker}
              setLastSelectedPicker={(keyId:string) => setLastSelectedPicker(keyId)}
              handleOnSelectColumnColor={handleOnSelectColumnColor}
              selectedColor={modalData.customColumnsColors[key.id]? modalData.customColumnsColors[key.id] : ""}
              defaultColor={resultsColsGeneratedColors? resultsColsGeneratedColors[key.id] : ""}
              initialValue={modalData.selectedColumns.indexOf(key.id) !== -1}
              simple={true}
              key={key.name}
              handleOnSelectRole={handleOnSelectColumn}
              id={key.id}
              text={key.name}/>
          );
        });
      } else {
        // table
        let filteredResult:IBtnOption[] = [];
  
        if (mode === "onlySelected") {
          result.resultKeysExtr.forEach((col:IBtnOption) => {
            if (modalData.selectedColumns.indexOf(col.id) !== -1) {
              filteredResult.push(col);
            }
          });
        } else {
          result.resultKeysExtr.forEach((col:IBtnOption) => {
            let matched = false;
            selectedModalFilteringOptions.forEach((selectedOption) => {
              if (!col.id.includes(selectedOption)) {
                matched = true;
              } 
            });
            if (!matched) {
              filteredResult.push(col);
            }
          });
          filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
        }
        return filteredResult.map((key:IBtnOption) => <CustomCheckbox initialValue={modalData.selectedColumns.indexOf(key.id) !== -1}  simple={true} key={key.name} handleOnSelectRole={handleOnSelectColumn} id={key.id} text={key.name}/>);
      }
    }
    
    if (source === "model_configuration") {
      let filteredResult:IBtnOption[] = [];
      if (mode === "onlySelected") {
        result.modelConfigKeysExtr.forEach((col:IBtnOption) => {
          if (modalData.selectedColumns.indexOf(col.id) !== -1) {
            filteredResult.push(col);          
          } 
        });
        filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
      } else {
        result.modelConfigKeysExtr.forEach((col:IBtnOption) => {
          if (!selectedModalFilteringOptions.some((selectedOption) => !col.id.includes(selectedOption))) {
            filteredResult.push(col);
          } 
        });
        filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
      }
      
      return filteredResult.map((key:IBtnOption) => <CustomCheckbox initialValue={modalData.selectedColumns.indexOf(key.id) !== -1}  simple={true} key={key.name} handleOnSelectRole={handleOnSelectColumn} id={key.id} text={key.name}/>);
    }
    
    if (source === "model") {
      let filteredResult:IBtnOption[] = [];
      if (mode === "onlySelected") {
        result.modelKeysExtr.forEach((col:IBtnOption) => {
          if (col.id !== "threshold" && modalData.selectedColumns.indexOf(col.id) !== -1) {
            filteredResult.push(col);          
          } 
        });
        
        filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
      } else {
        result.modelKeysExtr.forEach((col:IBtnOption) => {
          if (col.id !== "threshold" && !selectedModalFilteringOptions.some((selectedOption) => !col.id.includes(selectedOption))) {
            filteredResult.push(col);
          } 
        });
        filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
      }
      
      return filteredResult.map((key:IBtnOption) => <CustomCheckbox initialValue={modalData.selectedColumns.indexOf(key.id) !== -1}  simple={true} key={key.name} handleOnSelectRole={handleOnSelectColumn} id={key.id} text={key.name}/>);
    }
    
    if (source === "source_data") {
      let filteredResult:IBtnOption[] = [];
      if (mode === "onlySelected") {
        result.sourceDataKeysExtr.forEach((col:IBtnOption) => {
          if (col.id !== "threshold" && modalData.selectedColumns.indexOf(col.id) !== -1) {
            filteredResult.push(col);          
          } 
        });
        filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
      }else {
        result.sourceDataKeysExtr.forEach((col:IBtnOption) => {
          if (col.id !== "threshold" && !selectedModalFilteringOptions.some((selectedOption) => !col.id.includes(selectedOption))) {
            filteredResult.push(col);
          } 
        });
        filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
      }
      return filteredResult.map((key:IBtnOption) => <CustomCheckbox initialValue={modalData.selectedColumns.indexOf(key.id) !== -1}  simple={true} key={key.name} handleOnSelectRole={handleOnSelectColumn} id={key.id} text={key.name}/>);
    }
    
    if (source === "history") {
      if (modalData.widget_type === "chart"){
        // chart
        // we display threshhold as x-axis
        let filteredResult:IBtnOption[] = [];
  
        if (mode === "onlySelected") {
          result.historyKeysExtr.forEach((col:IBtnOption) => {
            if (col.id !== "threshold" && modalData.selectedColumns.indexOf(col.id) !== -1) {
              filteredResult.push(col);          
            } 
          });
        } else {
          result.historyKeysExtr.forEach((col:IBtnOption) => {
            if (col.id !== "threshold" && !selectedModalFilteringOptions.some((selectedOption) => !col.id.includes(selectedOption))) {
              filteredResult.push(col);
            } 
          });
          filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
        }
        return filteredResult.map((key:IBtnOption) => {
          return (
            <CustomCheckbox
              withInnerHeight={"#modalInputsWrapper"}
              lastSelectedPicker={lastSelectedPicker}
              setLastSelectedPicker={(keyId:string) => setLastSelectedPicker(keyId)}
              handleOnSelectColumnColor={handleOnSelectColumnColor}
              selectedColor={modalData.customColumnsColors[key.id]? modalData.customColumnsColors[key.id] : ""}
              defaultColor={resultsColsGeneratedColors? resultsColsGeneratedColors[key.id] : ""}
              initialValue={modalData.selectedColumns.indexOf(key.id) !== -1}
              simple={true}
              key={key.name}
              handleOnSelectRole={handleOnSelectColumn}
              id={key.id}
              text={key.name}/>
          );
        });
      } else {
        // table
        let filteredResult:IBtnOption[] = [];
  
        if (mode === "onlySelected") {
          result.historyKeysExtr.forEach((col:IBtnOption) => {
            if (modalData.selectedColumns.indexOf(col.id) !== -1) {
              filteredResult.push(col);
            }
          });
        } else {
          result.historyKeysExtr.forEach((col:IBtnOption) => {
            let matched = false;
            selectedModalFilteringOptions.forEach((selectedOption) => {
              if (!col.id.includes(selectedOption)) {
                matched = true;
              } 
            });
            if (!matched) {
              filteredResult.push(col);
            }
          });
  
          filteredResult = filterByVal? filterArrOfObjByString(filteredResult, "name", filterByVal) : filteredResult;
        }
  
        return filteredResult.map((key:IBtnOption) => <CustomCheckbox initialValue={modalData.selectedColumns.indexOf(key.id) !== -1}  simple={true} key={key.name} handleOnSelectRole={handleOnSelectColumn} id={key.id} text={key.name}/>);
      }
    }
  };

  const handleOnChange = (targetVal: string, inputKey: string, id: string) => {
    if (inputKey === "template") {
      if (getTemplateLayoutsData && getTemplateLayoutsData.rows.length !== 0) {
        const matchWithExistingLayouts = getTemplateLayoutsData.rows.find((row: ITableRowData) => row.id === id && targetVal === row.name);
        if (matchWithExistingLayouts) {
          setSelectedTemplateModal(prevState =>({...prevState, template: matchWithExistingLayouts.name, template_id: matchWithExistingLayouts.id}));
        } else {
          setSelectedTemplateModal(prevState =>({...prevState, template: targetVal, template_id: id}));
        }
      }
      return;
    }
    if (modalData.name === "Model configuration") {
      setModalData((prevState) => ({ ...prevState, steps: [{ key: inputKey, name: targetVal, layout: [], layoutItems: [] }] }));
      return;
    }
    if (modalData.name === "Tabs Widget") {
      if (modalData.steps.length === 0) {
        // first step
        setModalData((prevState) => ({ ...prevState, steps: [{ key: inputKey, name: targetVal, layout: [], layoutItems: [] }] }));
      } else {
        // edit
        let matched = false;
        let stepsData = modalData.steps.map((step: IStep) => {
          if (step.key === inputKey) {
            matched = true;
            return {key: inputKey, name: targetVal, layout: step.layout, layoutItems: step.layoutItems};
          } else {
            return step;
          }
        });
        if (!matched) {
          // no match => add a new step
          stepsData = [...stepsData, {key: inputKey, name: targetVal, layout: [], layoutItems: []}];
        }
        setModalData((prevState) => ({ ...prevState, steps: stepsData }));
      }
    } else {
      if (
        (inputKey === "source" && targetVal !== modalData.source && modalData.source !== "") ||
        (inputKey === "widget_type" && targetVal !== modalData.widget_type && modalData.widget_type !== "")
      ) {
        // when switching source or type, empty selected colums
        setModalData((prevState) => ({ ...prevState, [inputKey]: targetVal, selectedColumns: [] }));
      } else {
        if (inputKey === "dataset") {
          setModalData((prevState) => ({ ...prevState, [inputKey]: targetVal, dataset_id: id }));
        } else {
          setModalData((prevState) => ({ ...prevState, [inputKey]: targetVal }));
        }
      }
    }
  };

  const memorizedPrint = useMemo(() => {
    if (Object.keys(modalData).length !== 0 && modalData.constructor === Object) {
      let modalFields: IColumn[] = [];
      let stepsData: any = {}; // eslint-disable-line
  
      if (modalData.name === "Tabs Widget") {
        if (modalData.steps.length === 0) {
          // initial step
          const initialStepKey = createUUID();
          setModalData({...modalData, steps: [...modalData.steps, {key: initialStepKey, name: "", layout: [], layoutItems: []}] });
          modalFields = [
            {
              key: initialStepKey,
              displayName: "Tab 1",
              dataType: {
                type: "text",
              }
            },
          ];
        } else {
          modalFields = modalData.steps.map((step:IStep, i:number) => {
            stepsData = {...stepsData, [step.key] : step.name};
            return {
              key: step.key,
              displayName: `Tab ${i+1}`,
              dataType: {
                type: "text",
              }
            };
          });
        }
      } else if (modalData.name === "Text") {
        modalFields = [
          {
            key: "textType",
            displayName: "Text type",
            dataType: {
              type: "enumeration",
              values: textWidgetOptionsReport
            }
          },
        ];
        if (modalData.textType === "text") {
          modalFields = [
            ...modalFields,
            {
              key: "text",
              displayName: "Text",
              dataType: {
                type: "textarea",
              }
            },
          ];
        } else if (modalData.textType === "header") {
          modalFields = [
            ...modalFields,
            {
              key: "text",
              displayName: "Text",
              dataType: {
                type: "text",
              }
            },
          ];
        }
      } else if (modalData.name === "Custom widget") {
        modalFields = [
          {
            key: "source",
            displayName: "Source",
            dataType: {
              type: "enumeration",
              values: reportWidgetSources
            },
            extraClass: "half"
          },
          {
            key: "widget_type",
            displayName: "Widget type",
            dataType: {
              type: "enumeration",
              values: modalData.source === "report_data" || modalData.source=== "history" ? widgetOptions : [{ name: "Table", id: "table" }]
            },
            extraClass: "half"
          }
        ];
      }
      else if (modalData.tabWidgetId) {
        modalFields = [
          {
            key: "name",
            displayName: "Widget",
            dataType: {
              type: "enumeration",
              values: widgetType
            }
          },
          ...modalFields
        ];
      }
  
      let allMetrics = [
        [
          {
            metrics: [...coreMetrics],
            excludeOnSelect: ["alert", "transaction", "consolidated" , "entity"]
          },
          {
            metrics: [...subCoreMetrics],
            excludeOnSelect: ["amount", "count"]
          },
          {
            metrics: [...subCoreDetailsMetrics],
            excludeOnSelect: ["tp", "tn", "_p", "fpr", "fp", "fn"]
          },
        ]
      ];
  
      let allMetricsRight = [
        {
          metrics: [...metrics6],
          excludeOnSelect: ["precision", "recall", "specificity"]
        },
      ];
      if (modalData.source !== "history") {
        allMetricsRight = [{
          metrics: [...metrics4],
          excludeOnSelect: ["test", "train", "tvtr"]
        },
        {
          metrics: [...metrics5],
          excludeOnSelect: ["median", "min", "max", "avg", "std"]
        }, ...allMetricsRight];
      }
  
      allMetrics = [...allMetrics, allMetricsRight];
  
      return (
        <Fragment>
          <div onScroll={() => {setLastSelectedPicker("scrollAction");}} style={{paddingRight: `${modalData.steps.length >= 6? "15px" : ""}`}} id="modalInputsWrapper" className="reportDetails-modalInputsWrapper">
            {(unblockInput && !lock) && <RenderFields 
              deleteInput={(id: string) => {
                setModalData({...modalData, steps: modalData.steps.filter((step:IStep) => step.key !== id)});
              }} 
              fields={[...modalFields]} data={modalData.name === "Tabs Widget" ? stepsData : modalData} 
              handleOnChange={handleOnChange}
            />}
            {(modalData.source && modalData.widget_type) ? <Fragment>
              {(modalData.source === "report_data" || modalData.source === "history") && 
              <Fragment>
                {(unblockInput && !lock) && <div className="reportDetails-metricsLabel">Filter metrics</div>}
                {(unblockInput && !lock) && allMetrics.map((metricCol, i) => {
                  return (
                    <div key={i} className="reportDetails-aggregateBtns1">                    
                      {metricCol.map((metricData, i) => (
                        <div key={i}>
                          {metricData.metrics.map((optionData, i) => {
                            return (
                              <CustomCheckbox
                                simple={true}
                                key={i}
                                handleOnSelectRole={() => {
                                  setSelectedModalFilteringOptions((prev) => {
                                    if (prev.indexOf(optionData.key) === -1) {
                                      const result = prev.filter((opt) =>  {
                                        return metricData.excludeOnSelect.indexOf(opt) === -1;
                                      });
                                      return [...result, optionData.key];
                                    } else {
                                      return prev.filter((opt) => opt !== optionData.key);
                                    }
                                  });
                                }}
                                id={optionData.key} 
                                text={optionData.label}
                                initialValue={selectedModalFilteringOptions.indexOf(optionData.key) !== -1}
                              />
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  );
                })}
  
              </Fragment>}
  
              {(unblockInput && !lock) && <TextInput
                type={"text"}
                extraClass={modalData.source === "history" ? "half" : ""}
                id={"reportDetails-searchUserInput"}
                required={false}
                inputKey={"filterColumnsWith"}
                autofocus={false}
                placeholder={"Type to filter"}
                handleOnChange={(targetVal) => setFilterByVal(targetVal)}
              />}
  
              {modalData.source === "history" ?
                <Fragment>
                  <TextInput
                    label="Threshold"
                    type={"number"}
                    subType= "number"
                    allowedByParent={true}
                    controlled={true}
                    value={modalData?.selectedThreshold ? Number(modalData?.selectedThreshold) : ""}
                    inputTypeLimit={1}
                    extraClass={modalData.source === "history" ? (unblockInput && lock) || !unblockInput && lock? "" : "half" : ""}
                    id={"reportDetails-searchUserInput"}
                    required={true}
                    inputKey={"selectedThreshold"}
                    autofocus={false}
                    defineStep={() => defineStep(getHistoryColsData?.rows.thresholds)}
                    decimalsFormatting={getHistoryColsData?.rows.thresholds? getHistoryColsData?.rows.thresholds : 11}
                    placeholder={`e.g. ${defineStep(getHistoryColsData?.rows.thresholds)}`}
                    handleOnChange={handleOnChange}
                  />
                </Fragment>
                : ""}
  
              {(unblockInput && !lock) && <div>
                <div className="reportDetails-popup-buttonsWrapper">
                  {widgetColumnsBtns(modalData.source)}
                </div>
  
                <span className={"reportDetails-selectedColumsPoolWrapper"}>
                  <div className={"metricsPoolTitle"}>Selected metrics: </div>
                  {modalData.selectedColumns.length !== 0 ? widgetColumnsBtns(modalData.source, "onlySelected") : <span className="reportDetails-noMetricsMsgs">No metrics have been selected</span>}
                </span>    
              </div>}
            </Fragment> : ""}
            
          </div>
          {modalData.name === "Tabs Widget" && <Button
            name="add"
            onClick={() => setModalData({...modalData, steps: [...modalData.steps, {key: createUUID(), name: "", layout: [], layoutItems: []}] })}
            className="normalTable-new"
            variant="primary"
          >
            <AiOutlinePlus />
          </Button>}
        </Fragment>
      );
    }
  }, [modalData, extKeys, filterByVal, lastSelectedPicker, resultsColsGeneratedColors, selectedModalFilteringOptions, resultDataColsWithLabelsTransformed, setLastSelectedPicker]);
  

  const setModalDataFromBlock = (id: string, layoutItemsLoc: IBlock[], mainLayoutParent: IBlock[], newTabWidget: boolean, tabWidgetEdit?: string) => {
    const findItemBlock = layoutItemsLoc.filter((block:IBlock) => block.id === id);
    setModalData({ 
      mainLayoutParent,
      customColumnsColors: findItemBlock[0].settings?.customColumnsColors ? {...findItemBlock[0].settings?.customColumnsColors} : {},
      id: newTabWidget? "" : id,
      tabWidgetId: newTabWidget? id : (tabWidgetEdit? tabWidgetEdit : ""),
      steps: findItemBlock[0].steps,
      selectedThreshold: findItemBlock[0].settings?.selectedThreshold,
      name: newTabWidget ? "" : findItemBlock[0].optionName, 
      textType: findItemBlock[0].textType? findItemBlock[0].textType : "",
      text: findItemBlock[0].text? findItemBlock[0].text : "",  
      ...findItemBlock[0].settings
    });
  };

  const renderOptionsBtns = (options: IOption[]) => {
    const checkModalConfigExist = layoutItems.find((item) => item.optionName === "Model configuration");
    return options.map((option: IOption, i: number) => {
      if (checkModalConfigExist && option.name === "Model configuration") {
        return "";
      } else {
        return (
          <span key={i} className="blank" onClick={() => {
            if (option.name === "Custom widget" || option.name === "Text" || option.name === "Tabs Widget") {
              setModal(true);
              // set the name of the unique widgets
              setModalData({...modalData, name: option.name});
            }
            else {
              onBlockAdd(option.name, option.settings);
            }
          }}>
            {option.displayName} +
          </span>
        );
      }
    });
  };

  const generatePdfHandler = (mode:string) => {
    const prepareOrdering = pdfLayoutItems.map((item: IBlock) => {
      const findLayout = pdfLayout.find(layoutElement => layoutElement.i === item.id);

      if (item.optionName === "Text") {
        return {
          type: item.textType?.toLowerCase(),
          y: findLayout?.y || 0,
          content: item.text,
        };
      } else if (item.settings?.source === "history") {
        return {
          y: findLayout?.y || 0,
          source: item.settings?.source,
          type: item.settings?.widget_type.toLowerCase(),
          columns: item.settings?.selectedColumns.map((col:string) => {
            return { 
              header: historyDataColsWithLabels?.[col] ? historyDataColsWithLabels?.[col] : convertKeyIntoName(col), 
              key: col,
              custom_color: item.settings?.customColumnsColors[col]
            };}),
          threshold: item.settings?.selectedThreshold,
        };
      } else {
        return {
          y: findLayout?.y || 0,
          source: item.settings?.source,
          type: item.settings?.widget_type.toLowerCase(),
          show_only_for_threshold: item.settings?.show_only_for_threshold,
          columns: item.settings?.selectedColumns.map((col:string) => { 
            return {
              header: resultDataColsWithLabels?.[col] ? resultDataColsWithLabels?.[col] : convertKeyIntoName(col), 
              key: col,
              custom_color: item.settings?.customColumnsColors[col]
            };}),
        };
      }
    });
    const sortedResult = prepareOrdering.sort((a, b) => a.y - b.y);
    const cleanedUp  = sortedResult.map((item: IPreparedItem) => {
      const result = {...item};
      delete result["y"];
      return result;
    });
    if (mode === "download") {
      postGeneratePdf(`report/${params.id}/pdf`, {report_id: params.id, content: cleanedUp}, undefined, "none");
    } else if (mode === "preview") {
      postGeneratePdfPreview(`report/${params.id}/pdf`, {report_id: params.id, content: cleanedUp}, undefined, "none");
    }
  };

  const memorizedPrintPreview = () => {
    return (
      <Fragment>
        {preview && <Preview data={preview.blob} />}
      </Fragment>
    );
  };

  const handlePreviewModalClosed = () => {
    setPreviewModal(false);
  };

  const handlePreviewSubmit = () => {
    if (preview) {
      const url = window.URL.createObjectURL(preview.blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", preview.filename);
      document.body.appendChild(link);
      link.click();
      setPreviewModal(false);
    }
  };
  useEffect(() => {
    if (postTemplateLayoutStatus === "completed") {
      if (postTemplateLayoutData && postTemplateLayoutData.id) {
        setSelectedTemplateModal({
          ...selectedTemplateModal,
          template_id: postTemplateLayoutData.id
        });
      }
    }
  }, [postTemplateLayoutStatus, postTemplateLayoutData]);

  const latestTemplateIdRef = useRef("");

  useEffect(() => {
    if (getTemplateLayoutStatus === "completed" && latestTemplateIdRef.current) {
      getReportDetails(`report/${params.id}`, undefined, undefined, "none");
      latestTemplateIdRef.current = reportDetailsData.selected_template_layout_id;
    }
  }, [getTemplateLayoutStatus]);

  const [triggerFetch, setTriggerFetch] = useState(true);

  useEffect(() => {
    if (postTemplateLayoutStatus === "completed" && latestTemplateIdRef.current) {
      postSelectTemplateLayout(
        `select_template_layout/${reportDetailsData.dataset_id}/analytics_report_template`,
        {
          selected_template_layout_id: postTemplateLayoutData.id,
        }, 
        undefined, 
        "Template applied successfully"
      );
    }
  }, [postTemplateLayoutStatus, postTemplateLayoutData]);

  useEffect(() => {
    if (postSelectTemplateLayoutStatus === "completed" && !postSelectTemplateLayoutError) {
      getReportDetails(`report/${params.id}`, undefined, undefined, "Template applied successfully");
      setIsDirty(false);
    
      setSaveAsNewTemplateModal({show: false, template: "", template_id: ""});
      setModalState({isOpen: false, rowId: undefined});
      setLock(true);
    
      latestTemplateIdRef.current = "";
    }
  }, [postSelectTemplateLayoutStatus]);
  const handleSubmitTemplateAsNew = function () {
    if (!saveAsNewTemplateModal.template) { 
      return;
    }

    const newId = createUUID();
    latestTemplateIdRef.current = newId;
  
    const updatedLayout = JSON.stringify({ layout, layoutItems, lock: true });
  
    postTemplateLayout(
      `template_layout/${newId}`,
      {
        id: newId,
        name: saveAsNewTemplateModal.template,
        layout: updatedLayout,
        tenant_default: false,
        archived: false,
        is_installation: false,
        is_global: false,
        process: "report",
        template_type: "analytics_report_template",
      },
      "Template created successfully"
    );
  
    setSaveAsNewTemplateModal({
      show: true,
      template: saveAsNewTemplateModal.template,
      template_id: newId,
    });
  };
  
  useEffect(function () {
    if (saveAsNewTemplateModal.template_id && reportDetailsData) {
      postSelectTemplateLayout(
        `select_template_layout/${reportDetailsData.dataset_id}/analytics_report_template`,
        {
          selected_template_layout_id: saveAsNewTemplateModal.template_id,
        },
        "none"
      );
  
      setSaveAsNewTemplateModal({
        show: false,
        template: "",
        template_id: "",
      });
    }
  }, [saveAsNewTemplateModal.template_id]);
  
  useEffect(() => {
    if (triggerFetch && reportDetailsData?.selected_template_layout_id) {
      getTemplateLayout(
        `template_layout/${reportDetailsData.selected_template_layout_id}`,
        undefined,
        undefined
      );
    
      setTriggerFetch(false);
    }
  }, [triggerFetch, reportDetailsData?.selected_template_layout_id, getTemplateLayoutStatus]);

  useEffect(() => {
    if (layoutInstance !== 0 && layoutItems && layoutItems.some(item => item.optionName === "Model configuration")) {
      setLayoutInstance(0);
      const modelConfig = layoutItems.find(item => item.optionName === "Model configuration");
      if (modelConfig?.selectedColumns) {
        setSelectedModelConfigColumns(
          modelConfig.selectedColumns ? modelConfig.selectedColumns.map((col: any) => ({ // eslint-disable-line
            key: col,
            displayName: col
          })) : selectedModelConfigColumns
        );
      }
    }
    const checkModalConfigExist = layoutItems.find((item) => item.optionName === "Model configuration");
    if (!checkModalConfigExist && layoutInstance === 1) {
      setSelectedModelConfigColumns([]);
    }
  }, [layoutItems]);

  const saveAsNewTemplateTemplateModal = useMemo(() => {
    const newID = createUUID();
    return (
      <TextInput
        type={"text"}
        id={newID}
        required={true}
        inputKey={"template"}
        autofocus={false}
        controlled={true}
        value={saveAsNewTemplateModal.template}
        placeholder={"Enter template name"}
        handleOnChange={(targetVal) => setSaveAsNewTemplateModal({...saveAsNewTemplateModal, template: targetVal})}
      />
    );
  }, [saveAsNewTemplateModal]);

  const renderProductionModalBody = () => {
    let defineName = postSendToProductionData? `${authCtx.name} ${authCtx.lastName}` : reportDetailsData?.user_name;
    let defineDate = postSendToProductionData? new Date(postSendToProductionData.date).toLocaleDateString() : new Date(reportDetailsData?.last_comment_date).toLocaleDateString();
    let defineComment = postSendToProductionData? postSendToProductionData.comment : reportDetailsData?.last_comment;

    if (postSendToProductionStatus === "pending") {
      defineName = `${authCtx.name} ${authCtx.lastName}`;
      defineDate = new Date().toLocaleDateString();
      defineComment = productionModalData.comment;
    }

    const renderPopupMessage = () => {
      // empty state => no msg
      if (postSendToProductionData && postSendToProductionData?.state && productionModalData?.state === "production" || productionModalData?.state === "test") {
        // i know its me who did the last
        if (postSendToProductionData?.state === "pending_production_approval" && productionModalData?.state !== "test") {
          return "Putting this run into production requires another user to approve the action.";
        } else if (postSendToProductionData?.state === "production" && productionModalData?.state !== "test") {
          return "Putting this model into Production will overwrite the previous Production model (code & aggregates)";
        } else if (postSendToProductionData?.state === "test" && productionModalData?.state !== "production") {
          return "Putting this model into Test will allow you test the model (code & aggregates) in a non-production environment.";
        }
      }
      if (reportDetailsData?.user_id) {
        if (productionModalData.state === "production" && reportDetailsData.state === "production") {
          return "Putting this model into Production will overwrite the previous Production model (code & aggregates)";
        } 
        if (productionModalData.state === "test" && reportDetailsData.state === "test") {
          return "Putting this model into Test will allow you test the model (code & aggregates) in a non-production environment.";
        }
        if (reportDetailsData.state === "pending_production_approval" && productionModalData.state === "production") {
          return "Putting this run into production requires another user to approve the action.";
        }
      }
      if (productionModalData.state === "production") {
        return "Putting this model into Production will overwrite the previous Production model (code & aggregates)";
      } else if (productionModalData.state === "test") {
        return "Putting this model into Test will allow you test the model (code & aggregates) in a non-production environment.";
      }
    };

    return (
      <Fragment>
        {reportDetailsData?.user_id || postSendToProductionData? 
          <div className="popup-editedBy">
            <div className="popup-editedBy-title">Updated by - {defineName} {defineDate}</div>
            <div><span className="importantLine">Note:</span>{defineComment}</div>
          </div> : ""}

        <div className="popup-textWrapper">
          {renderPopupMessage()}
        </div>
        <RenderFields 
          fields={[...productionModalCols]} data={productionModalData} 
          handleOnChange={(targetVal: string, inputKey: string) => setProductionModalData((prevState) => ({ ...prevState, [inputKey]: targetVal }))}
        />
        <div className="popupMessageOffset">
          <span className="importantLine">Important:</span>
          Changing the State of a model will overwrite any previous model (code & aggregates) in that State.
        </div>
      </Fragment>
    );
  };

  const handleSendToProduction = () => {
    if (reportDetailsStatus === "completed" && !reportDetailsError && reportDetailsData) {
      const defineSource = postSendToProductionData? postSendToProductionData : reportDetailsData;

      if (defineSource.state !== productionModalData.state) {
        let defineState = productionModalData.state;

        if (defineSource.user_id !== authCtx.userId) {
          if (defineSource.state !== "pending_production_approval" && productionModalData.state === "production") {
            defineState = "pending_production_approval";
          }
        } else {
          if (defineSource.state !== "pending_production_approval" && productionModalData.state === "production") {
            defineState = "pending_production_approval";
          }
        }
        postSendToProduction("state_approval", {state: defineState, comment: productionModalData.comment, selected_threshold: productionModalData.selected_threshold, report_id: params.id});
      }
    }
  };

  const checkValidationStatus = () => {
    if (postSendToProductionData) {
      return validateLoadingStatusNew([postSendToProductionStatus]) ||
      postSendToProductionData?.state === "pending_production_approval" && productionModalData?.state === "production" ||
      postSendToProductionData && postSendToProductionData?.state === productionModalData?.state;
    } else {
      return validateLoadingStatusNew([postSendToProductionStatus]) || 
      reportDetailsData?.state === productionModalData?.state ||
      reportDetailsData?.state === "production" && productionModalData?.state === "production" ||
      reportDetailsData?.user_id === authCtx.userId && reportDetailsData?.state === "pending_production_approval" && productionModalData?.state === "production";
    }
  };
  const getModalContent = () => {
    return (
      <p> You made some changes on template: {reportDetailsData?.selected_template_layout_name}. Please select an action to continue.</p>
    );
  };

  const handleSaveTemplateClick = () => {
    setModalState({ isOpen: true, rowId: reportDetailsData.selected_template_layout_id });
  };

  const handleDiscard = () => {
    getTemplateLayout(
      `template_layout/${reportDetailsData.selected_template_layout_id}`,
      undefined,
      undefined,
      "Template reverted successfully"
    );
    setLock(true);
    setIsDirty(false);
    setFlag(false);
    setModalState({ isOpen: false, rowId: undefined });
    next();
  };

  return (
    <div className="reportDetails">
      {flag && <CustomModal 
        show={flag}
        onHide={() => {
          setModalState({
            isOpen: false,
            rowId: undefined,
          });
        }}
        title={
          "Confirm Action"
        }
        confirmButtonText={""}
        onConfirm={undefined}>{getModalContent()}</CustomModal>}

      {generatePdfPreviewStatusPost === "completed" && <SimpleModal type="large" wrapperClass={"pdfModal"} modalBody={memorizedPrintPreview()} buttonText={"Download"} mode={"PDF Preview"} handleModalClosed={handlePreviewModalClosed} handleSubmit={handlePreviewSubmit} show={previewModal}/>}
      <SimpleModal 
        wrapperClass={`reportDetails-${modalData.name !== "Tabs Widget" && modalData.name !== "Text"? "featureSelectionModal" : ""} ${(unblockInput && lock) || !unblockInput? "miniModal" : ""}`} 
        onModalClickHandler={onModalClickHandler} 
        modalBody={memorizedPrint} 
        buttonText={"Save"}
        actionButtonDisabled={validateLoadingStatusNew([postSelectTemplateLayoutStatus, getTemplateLayoutStatus, postTemplateLayoutStatus, modelDataStatus, getResultDataByColsStatus, sourceDataStatus, reportDetailsStatus])}
        mode={"Widget settings"}
        handleModalClosed={handleModalClosed} 
        handleSubmit={handleSubmit}
        show={modal}
      />
      <SimpleModal
        modalBody={renderProductionModalBody()} 
        buttonText={"Approve"}
        actionButtonDisabled={checkValidationStatus()}
        mode={"Production"} 
        handleModalClosed={() => {
          setProductionModal(false);
          if (postSendToProductionStatus === "completed" && !postSendToProductionError) {
            setProductionModalData({...productionModalData, comment: "", last_comment: postSendToProductionData.comment});
          } else {
            reportDetailsData && setProductionModalData({
              ...reportDetailsData,
              state: reportDetailsData.state === "pending_production_approval"? "production" : reportDetailsData.state,
              last_comment: reportDetailsData.comment? reportDetailsData.comment : "",
            });
          }
        }} 
        handleSubmit={handleSendToProduction} 
        show={productionModal}
      />
      <SimpleModal
        modalBody={saveAsNewTemplateTemplateModal}
        buttonText={"Save"}
        mode={"Save as New Template"}
        handleModalClosed={() => setSaveAsNewTemplateModal({...saveAsNewTemplateModal, show: false})}
        handleSubmit={handleSubmitTemplateAsNew}
        show={saveAsNewTemplateModal.show}
      />
      <SimpleModal
        show={thresholdConfirmModal.show}
        mode="Change threshold"
        buttonText="Yes"
        showCancelButton={true}
        modalBody={
          <p>
            Are you sure you want to change the threshold to <strong>{thresholdConfirmModal.pendingIds[0]}</strong>?
          </p>
        }
        handleSubmit={() => {
          handleThresholdChange(thresholdConfirmModal.pendingIds);
        }}
        handleModalClosed={() => setThresholdConfirmModal({ show: false, pendingIds: [], pendingFullData: [] })}
      />

      {modalState.isOpen && (
        <CustomModal
          show={modalState.isOpen}
          onHide={() => {
            setModalState({
              isOpen: false,
              rowId: undefined,
            });
          }}
          title={
            "Confirm Action"
          }
          confirmButtonText={""}
          onConfirm={undefined}
        >
          {getModalContent()}
        </CustomModal>
      )}

      {validateLoadingStatusNew([generatePdfStatusPost, getDownloadModelStatus, postSendToProductionStatus, postSelectTemplateLayoutStatus, getTemplateLayoutStatus, postTemplateLayoutStatus, getTemplateLayoutsStatus, generatePdfPreviewStatusPost, pdfTemplateStatusGet, modelDataStatus, getResultDataByColsStatus, sourceDataStatus, reportDetailsStatus]) && <Spinner />}
      <span>
        <div onClick={() => onBackClick()} className="listPage-nav-btn">
          <BsArrowLeft />
        </div>
        <div className="reportDetails-controls">
          <h1>{reportDetailsData? reportDetailsData.name : "Report details"}</h1>
        </div>
      </span>
      
      <div className="reportDetails-btnWrapper">
        {!lock && unblockInput && renderOptionsBtns(optionsBlocks)}
        <span className="w-px h-6 bg-gray-400 mx-2"></span>

        <ToolTipGeneralInfo
          
          content={"Preview with a PDF layout"}
          direction="top"
          delay={350}
        >
          <Button 
            onClick={() => {
              generatePdfHandler("preview");
              setPreviewModal(true);
            }} 
            className="blank">
            <BsFillEyeFill />
          </Button>
        </ToolTipGeneralInfo>

        <ToolTipGeneralInfo
          
          content={"Download as PDF"}
          direction="top"
          delay={350}
        >
          <Button onClick={() => generatePdfHandler("download")} className="blank">
            <FaFileDownload />
          </Button>
        </ToolTipGeneralInfo>

        {unblockInput && (
          <Fragment>

            {!lock && (
              <ToolTipGeneralInfo  content={"Customize your PDF layout"} direction="top" delay={350}>
                <Button
                  disabled={!unblockInput}
                  className="blank"
                  onClick={() => navigate(`/analytics/reports/${params.id}/create-pdf`)}
                >
                  <FaFilePdf />
                </Button>
              </ToolTipGeneralInfo>
            )}
            <span className="w-px h-6 bg-gray-400 mx-2"></span>

            <ToolTipGeneralInfo  content={"Download the model"} direction="top" delay={350}>
              <Button
                disabled={!unblockInput}
                className="blank"
                onClick={() => {
                  getDownloadModel(`modelcode/${params.id}`);
                }}
              >
                <FaDownload />
              </Button>
            </ToolTipGeneralInfo>
            <ToolTipGeneralInfo
              
              content={"Audit log"}
              direction="top"
              delay={350}
            >
              <Button 
                onClick={() => navigate(`/analytics/reports/${params.id}/logs`)} 
                className="blank">
                <GrHistory />
              </Button>
            </ToolTipGeneralInfo>

            <ToolTipGeneralInfo  content={"Production"} direction="top" delay={350}>
              <Button
                className="blank"
                disabled={!unblockInput}
                onClick={() => setProductionModal(true)}
              >
                <BsFillSendCheckFill />
              </Button>
            </ToolTipGeneralInfo>
            <span className="w-px h-6 bg-gray-400 mx-2"></span>
            {!lock && 
              <ToolTipGeneralInfo    
                content={"Save the template"}
                direction="top"
                delay={350}
              >
                <Button 
                  onClick={handleSaveTemplateClick} 
                  className="blank">
                  <FaSave />
                </Button>
              </ToolTipGeneralInfo>
            }
            {!lock && <ToolTipGeneralInfo
              
              content={"Lock the editor"}
              direction="top"
              delay={350}
            >
              <Button
                disabled={!unblockInput}
                onClick={() => {
                  setLock(!lock);
                }}
                className="blank"
              >
                <BsFillUnlockFill />
              </Button>
            </ToolTipGeneralInfo>}

            {lock && <ToolTipGeneralInfo
              
              content={"Unlock the editor"}
              direction="top"
              delay={350}
            >
              <Button
                disabled={!unblockInput}
                onClick={() => {
                  setLock(!lock);
                  
                  setIsDirty(false);
                }}
                className="blank"
              >
                <BsLockFill />
              </Button>
            </ToolTipGeneralInfo>}
          </Fragment>
        )}
      </div>

      {reportDetailsData && <WidgetsLayout 
        layout={layout} 
        layoutItems={layoutItems} 
        getLayoutChanges={getLayoutChanges} 
        getLayoutItems={(data) => setlayoutItems(data)} 
        optionsBlocks={optionsBlocks}
        lock={lock}
        setModal={setModal}
        setModalDataFromBlock={setModalDataFromBlock}
        unblockInput={unblockInput}
        mainLayoutParent={[]}
      />}
    </div>
  );
};

export default ReportDetails;